module.exports = __webpack_public_path__ + "img/activate-device.492a512a.svg";